import Button from 'components/Button'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import CandidateRatingFilter from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Partials/CandidateRatingFilter'
import CandidateStatusFilter from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Partials/CandidateStatusFilter'
import CollegeNameFilter from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Partials/CollegeNameFilter'
import DegreeAndDepartmentFilter from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Partials/DegreeAndDepartmentFilter'
import GenderFilter from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Partials/GenderFilter'
import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Styles/style'
import React, { useState } from 'react'

const CandidateFilter = ({
  appliedCandidatesList,
  searchValue,
  setSearchValue,
  candidateRating,
  setCandidateRating,
  candidateStatus,
  setCandidateStatus,
  gender,
  setGender,
  instituteSearch,
  setInstituteSearch,
  degreeListData,
  checkedKeys,
  setCheckedKeys,
  checkedIds,
  setCheckedIds,
  institutesList,
  campusIds,
  setCampusIds,
  candidateFilterData,
  setCandidateFilterData,
  viewRoleDetails,
  campusLoading,
  setInstituteList,
  loadMoreData,
  draftData,
  instituteId,
  handleResumeDownloadClick,
  selectedStudentId
}) => {
 
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [activeTabKey, setActiveTabKey] = useState('1')
  const submitFilter = () => {
    setIsMenuOpen(false)
    setCandidateFilterData({
      status: candidateStatus[0] || '',
      degreeDepartment: checkedIds || [],
      degreekeys: checkedKeys,
      collegeName: campusIds.length > 0 ? campusIds[0] : instituteId,
      gender: gender[0] || '',
    })
  }

  const onCancelFilter = open => {
    setIsMenuOpen(!isMenuOpen)
    if (!open) {
      setCandidateRating(candidateFilterData?.rating)
      setCandidateStatus([candidateFilterData?.status])
      setCheckedIds(candidateFilterData?.degreeDepartment)
      setCheckedKeys(candidateFilterData?.degreekeys)
      setCampusIds([candidateFilterData?.collegeName])
      setGender([candidateFilterData?.gender])
    }
  }
  const handleTabChange = key => {
    setActiveTabKey(key)
  }

  const menu = (
    <MenuFlex column>
      <StyledTab
        border={true}
        tabPosition={'left'}
        type="card"
        padding="15px"
        width={'max-content'}
        overflow={activeTabKey == '1' ? 'hidden' : 'auto'}
        overflowX={activeTabKey == '1' ? 'hidden' : 'auto'}
        onChange={handleTabChange}
        items={[
          // {
          //   label: 'Candidate Rating',
          //   key: '1',
          //   hidden: !draftData?.isRankingActive,
          //   children: (
          //     <CandidateRatingFilter
          //       candidateRating={candidateRating}
          //       setCandidateRating={setCandidateRating}
          //     />
          //   ),
          // },
          {
            label: 'Candidate Status',
            key: '2',
            children: (
              <CandidateStatusFilter
                candidateStatus={candidateStatus}
                setCandidateStatus={setCandidateStatus}
              />
            ),
          },
          {
            label: 'Degree & Department',
            key: '3',
            children: (
              <DegreeAndDepartmentFilter
                degreeListData={degreeListData}
                checkedKeys={checkedKeys}
                setCheckedKeys={setCheckedKeys}
                checkedIds={checkedIds}
                setCheckedIds={setCheckedIds}
              />
            ),
          },
          !viewRoleDetails && {
            label: 'College Name',
            key: '4',
            children: (
              <CollegeNameFilter
                institutesList={institutesList}
                instituteSearch={instituteSearch}
                setInstituteSearch={setInstituteSearch}
                campusIds={campusIds}
                setCampusIds={setCampusIds}
                campusLoading={campusLoading}
                loadMore={loadMoreData}
              />
            ),
          },
          {
            label: 'Gender',
            key: '5',
            children: <GenderFilter gender={gender} setGender={setGender} />,
          },
        ].filter(item => !item.hidden)}
      />
      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={() => onCancelFilter(false)} />
        <Button.Primary text="Apply Filter" onClick={submitFilter} />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <TableSearchFilter
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      totalCount={appliedCandidatesList?.count}
      onOpenChange={onCancelFilter}
      currentCount={
        appliedCandidatesList?.count < 10
          ? appliedCandidatesList?.count
          : appliedCandidatesList?.result?.length +
            appliedCandidatesList?.page * 10
      }
      resumeEnable={true}
      handleResumeDownloadClick={handleResumeDownloadClick}
      selectedStudentId={selectedStudentId}
    />
  )
}

export default CandidateFilter
